import * as Tooltip from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { cn } from "@/components/ui/cn";

type VHoverCardProps = {
  trigger: ReactNode;
  children: ReactNode;
  delayDuration?: number;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  className?: string;
};

export function VHoverCard({
  trigger,
  children,
  delayDuration = 250,
  side = "bottom",
  align = "start",
  className,
}: VHoverCardProps): React.JSX.Element {
  return (
    <Tooltip.Provider delayDuration={delayDuration} skipDelayDuration={150}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{trigger}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            align={align}
            sideOffset={8}
            collisionPadding={12}
            className={cn(
              "z-50 w-80 max-w-[calc(100vw-2rem)] rounded-lg border border-border bg-card p-3.5 text-card-foreground shadow-xl outline-none",
              "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95",
              className,
            )}
          >
            {children}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
